import React from "react";
import { Button } from "react-bootstrap";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="enFooter">
        <div className="social-links">
          <a
            href="https://www.facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f"></i>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi bi-twitter"></i>
          </a>
          <a
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi bi-instagram"></i>
          </a>
        </div>

        <p>© 2025. Ahmed Restaurant. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

